import { createSingleton } from '@luna/utils';

import type { UserConfiguration } from './UserConfigurationTypes';

export type UserConfigurationSaveStrategy = {
    saveAll: (userConfiguration: UserConfiguration, options?: unknown) => void;
    saveOne: (
        id: string,
        userConfiguration: UserConfiguration[keyof UserConfiguration],
        options?: unknown,
    ) => void;
};
const userConfigurationSaveStrategy = createSingleton<UserConfigurationSaveStrategy>();

export const setUserConfigurationSaveStrategy = (callback: UserConfigurationSaveStrategy) => {
    userConfigurationSaveStrategy.set(callback);
};

export const getUserConfigurationStrategy = (): UserConfigurationSaveStrategy | undefined => {
    return userConfigurationSaveStrategy.get();
};
